/* import __COLOCATED_TEMPLATE__ from './brand-color-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();